import { v4 as uuidv4 } from "uuid";
import { addUserReading } from "../firebase/user";
import { firestore, storage } from "../firebase/config";
import Swal from 'sweetalert2';

const divID = "blueToothReadingsDivbloodGlucoseMeter";

export const onCaptureImageButtonClick3 = (uid) => {
  document.getElementById(divID).innerHTML = `ᛒ${divID}`;
  localStorage.setItem('completed_bgm', 10);
  CaptureImageComponent(uid);
};

async function CaptureImageComponent(userId) {
  try {
    const imageFile = await captureImage(); 
    const fileName = `${userId}/${uuidv4()}`;
    const storageRef = storage.ref(`images/${fileName}`);
    const snapshot = await storageRef.put(imageFile);
    const downloadURL = await snapshot.ref.getDownloadURL();

    const response = await fetch(
      "https://sharprpm-ocr-bgm-test1-850861419930.us-central1.run.app",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ data: downloadURL }),
      }
    );

    if (!response.ok) throw new Error("Failed to process image");
    
    const result = await response.json();
    handleConfirm(userId, downloadURL, result);
  } catch (error) {
    console.error("Error capturing or processing image:", error);
  }
}

async function handleConfirm(userId, imageURL, output) {
  const dateNow = new Date();
  document.getElementById(divID).innerHTML = `ᛒ${divID}`;
  localStorage.setItem('completed_bgm', 30);
  
  try {
    await firestore.collection("posts").add({
      userId,
      timestamp: dateNow,
      image: imageURL,
      response: output,
    });

    createTable(
      ["Glucose", "Date Time"],
      [output.glucose, dateNow.toLocaleString()],
      `table2`,
      imageURL,
      saveReading(userId, output, dateNow)
    );
  } catch (error) {
    console.error("Error confirming post:", error);
  }
}

async function captureImage() {
  return new Promise((resolve, reject) => {
    const input = document.createElement("input");
    input.type = "file";
    input.accept = "image/*";
    input.capture = "environment";
    
    input.addEventListener("change", (event) => {
      const file = event.target.files[0];
      file ? resolve(file) : reject(new Error("No image selected"));
    });
    
    input.click();
  });
}

function saveReading(uid, reading, dateTime) {
  const time = dateTime.toLocaleTimeString("en-US", {
    hour: "2-digit", minute: "2-digit", hour12: false,
  });
  const date = dateTime.toLocaleDateString().replace(/(\d+)\/(\d+)\/(\d+)/, "$3-$1-$2");
  
  let validationMsg = "";
  if (reading.glucose < 50 || reading.glucose > 400) {
    validationMsg = "<br>- Glucose level out of normal range (50-400 mg/dL)";
  }

  Swal.fire({
    title: 'Confirm Reading',
    html: `Glucose: ${reading.glucose} mg/dL <br>
      <span style="color: red; font-weight: bold;">${validationMsg}</span><br>
      If incorrect, press "Cancel", otherwise press "OK".`,
    icon: 'question',
    showCancelButton: true,
    confirmButtonText: 'OK',
    cancelButtonText: 'Cancel',
  }).then((result) => {
    const status = result.isConfirmed ? "Accepted" : "Rejected";
    addUserReading({
      uid,
      add: {
        devices: {
          bloodGlucoseMeter: {
            time, date, status,
            note: `Picture Captured`,
            reading: { Glucose: reading.glucose },
            device: { manufacturer: "Device", model: "Camera" },
          },
        },
      },
    });
    document.getElementById(`disposition_${divID}`).innerHTML = 
      status === "Accepted" ? "Reading saved!" : "Reading rejected.";
    if (status === "Accepted") new Audio('/audio/ReadingAccepted.mp3').play();
  });
}

function createTable(labelArray, colDataArray, tableClassName, imageURL) {
  if (document.getElementById(divID).innerHTML === `ᛒ${divID}`) {
    document.getElementById(divID).innerHTML = "";
    localStorage.setItem('completed_bgm', 100);
  }
  
  let table = document.createElement("table"),
    thead = document.createElement("thead"),
    tbody = document.createElement("tbody"),
    th, tr, td;

  th = document.createElement("th");
  th.innerHTML = "Camera";
  thead.appendChild(th);

  th = document.createElement("th");
  th.innerHTML = `<div id=disposition_${divID}>Reading pending</div>`;
  thead.appendChild(th);

  table.setAttribute("class", tableClassName);
  table.appendChild(thead);
  table.appendChild(tbody);

  //document.body.appendChild(table);
  document.getElementById(divID).appendChild(table);

  for (let i = 0; i < colDataArray.length; i++) {
    tr = document.createElement("tr");

    //for label
    td = document.createElement("td");
    td.innerHTML = labelArray[i];
    td.style.color = "blue";
    tr.appendChild(td);

    //for data
    td = document.createElement("td");
    td.style.color = "black";
    td.innerHTML = colDataArray[i];
    tr.appendChild(td);
    table.appendChild(tr);
  }

  tr = document.createElement("tr");
  td = document.createElement("td");
  td.colSpan = 2;

  const img = document.createElement("img");
  img.src = imageURL;
  // Set the width and height of the image (optional)
  img.width = "200";
  img.height = "150";
  // Append the image to the table data cell
  td.appendChild(img);
  tr.appendChild(td);

  tbody.appendChild(tr);
};